import React, { FunctionComponent } from 'react';
import Button, { IButtonProps } from 'bit/shared/button';
import useGlobal from 'hooks/useGlobal';
import * as s from './button-proxy.module.scss';

interface IButtonProxy extends IButtonProps {
  vertical?: boolean;
  newStyle?: boolean;
  load?: 'eager' | 'lazy';
  keepQuery?: boolean;
}

const ButtonProxy: FunctionComponent<IButtonProxy> = ({ newStyle, vertical, load, ...props }) => {
  const { className, black, justText, icon, lp, small } = props;
  const blackClass = black ? s.black : '';
  const lpClass = lp ? s.lp : '';
  const iconButtonClass = !justText && icon ? s.iconButton : '';
  const justTextAndIconClass = justText && icon ? s.iconAndText : '';
  const justTextClass = justText && !icon ? s.justText : '';
  const smallClass = small ? s.small : '';
  const newClass = newStyle ? s.newStyle : '';
  const verticalClass = vertical ? s.vertical : '';
  const proxyClasses = `${s.buttonProxy} ${className} ${justTextAndIconClass} ${justTextClass} ${iconButtonClass} ${blackClass} ${lpClass} ${smallClass} ${newClass} ${verticalClass}`;

  const defaultKeepQueryValue = props.keepQuery ?? true;

  return vertical ? (
    <Button {...props} keepQuery={defaultKeepQueryValue} styles={s} className={proxyClasses}>
      <img src="/svg/new-arrow.svg" alt="" />
      <span>{props.children || props.text}</span>
    </Button>
  ) : (
    <Button {...props} keepQuery={defaultKeepQueryValue} styles={s} className={proxyClasses} load={load || 'lazy'} />
  );
};

export default ButtonProxy;
